export default __webpack_public_path__ + "static/media/sponsor-futebol.5fe9a0af.png";